import ajax from '../../../components/ajax';
export default function useSimilarApi(productId) {
    function request(data) {
        data.product_id = productId;
        return ajax('/api/similar', data, { dataType: "json", })
            .then(function (response) { return response.json(); });
    }
    return {
        add: function (similar_id) { return request({ action: 'add', similar_id: similar_id }); },
        delete: function (similar_id) { return request({ action: 'delete', similar_id: similar_id }); },
        getActive: function () { return request({ action: 'get_active' }); },
        search: function (query) { return request({ action: 'search', query: query }); },
        vote: function (vote, similar_id) { return request({ action: 'vote', similar_id: similar_id, vote: vote }); },
    };
}
